import Reveal from '@/components/base/Reveal';

const brands = [
  {
    number: '01',
    name: 'Breakfast Republic',
    description:
      'A modern all-day breakfast and brunch concept built around bold flavors, creative dishes, great coffee, and an energetic atmosphere.',
    cta: 'Discover Breakfast Republic',
    image:
      'https://breakfastrepublic.com/wp-content/uploads/2020/02/home-photo-1-1.jpg',
    alt: 'Breakfast Republic restaurant interior and signature brunch plate',
  },
  {
    number: '02',
    name: 'Eggies',
    description:
      'A neighborhood-focused breakfast concept centered around approachable food, quality ingredients, and a welcoming everyday atmosphere.',
    cta: 'Discover Eggies',
    image:
      'https://eggies.com/wp-content/uploads/2019/03/Eggies_WhatCameFirst2.jpg',
    alt: 'Eggies signature breakfast sandwich and fresh breakfast plate',
  },
  {
    number: '03',
    name: 'OX Coffee',
    description:
      'A coffee-focused concept bringing quality coffee and a thoughtful café experience to the JEDL portfolio.',
    cta: 'Discover OX Coffee',
    image:
      'https://oxcoffeeroasters.com/wp-content/uploads/2024/02/OX-152.jpg',
    alt: 'OX Coffee cafe interior with espresso bar and seating',
  },
];

export default function Brands() {
  return (
    <section id="brands" className="py-24 md:py-32 px-6 md:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-[0.35em] text-primary-600">Our Brands</p>
            <h2 className="font-heading text-3xl md:text-5xl mt-6 text-foreground-950 leading-[1.1]">
              Different concepts. One hospitality mindset.
            </h2>
            <p className="mt-5 text-foreground-600 leading-relaxed">
              Each brand in the JEDL portfolio has its own identity, while sharing a common commitment to quality,
              consistency, and thoughtful hospitality.
            </p>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {brands.map((brand, i) => (
            <Reveal key={brand.name} delay={i * 100}>
              <article className="group bg-background-50 border border-background-200 overflow-hidden h-full flex flex-col">
                <div className="relative w-full h-56 overflow-hidden">
                  <img
                    src={brand.image}
                    alt={brand.alt}
                    title={`${brand.name} — JEDL Restaurants`}
                    className="w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
                <div className="p-6 md:p-7 flex flex-col flex-1">
                  <div className="flex items-center justify-between">
                    <span className="text-xs tracking-[0.25em] text-foreground-400">{brand.number}</span>
                    <span className="w-8 h-px bg-background-300"></span>
                  </div>
                  <h3 className="font-heading text-2xl mt-4 text-foreground-950">{brand.name}</h3>
                  <p className="mt-3 text-foreground-600 leading-relaxed text-sm">{brand.description}</p>
                  <a
                    href="#contact"
                    className="mt-6 inline-flex items-center gap-2 text-sm text-foreground-900 font-medium group-hover:text-primary-600 transition-colors whitespace-nowrap"
                  >
                    {brand.cta}
                    <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1"></i>
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}